<template>
  <div class="columns">
    <div class="column tablet:is-3 widescreen:is-2">
      <b-field label="N° Documento">
        <b-input
          v-model="numeroDocumento"
          type="is-info"
          placeholder="Ingrese número..."
          @keyup.enter.native="numeroDocumentoEnterHandle"
        />
      </b-field>
    </div>
    <div class="column tablet:is-3 widescreen:is-2">
      <b-field label="Tipo Documento">
        <div class="block">
          <b-radio v-model="tipoDocumento" type="is-info" native-value="P">
            Pedido
          </b-radio>
          <b-radio v-model="tipoDocumento" type="is-info" native-value="F">
            Factura
          </b-radio>
          <b-radio v-model="tipoDocumento" type="is-info" native-value="B">
            Boleta
          </b-radio>
        </div>
      </b-field>
    </div>
    <div class="column is-4">
      <div class="button-alignment">
        <b-button
          type="is-info"
          icon-left="search"
          :loading="cargando"
          :disabled="!puedeBuscar"
          @click="buscarPedido"
        >
          Buscar
        </b-button>
        &nbsp;
        <router-link
          v-if="desdeMonitor"
          class="button"
          type="button"
          tag="button"
          :to="{ path: urlVolver }"
        >
          Volver
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'VisorPedidosFiltros',
  props: {
    modo: {
      type: String,
      required: true
    },
    cargando: {
      type: Boolean,
      default: false
    },
    desdeMonitor: {
      type: Boolean,
      default: false
    },
    filtro: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      numeroDocumento: null,
      tipoDocumento: null
    }
  },
  computed: {
    ...mapGetters('monitor', ['bodega']),
    puedeBuscar() {
      return this.numeroDocumento && this.tipoDocumento
    },
    urlVolver() {
      return this.modo === 'despacho' ? '/despacho' : '/'
    }
  },
  watch: {
    filtro: {
      handler(val) {
        this.numeroDocumento = val.numeroDocumento
        this.tipoDocumento = val.tipoDocumento
      },
      deep: true
    }
  },
  mounted() {
    this.numeroDocumento = this.filtro ? this.filtro.numeroDocumento : ''
    this.tipoDocumento = this.filtro ? this.filtro.tipoDocumento : 'P'
  },
  methods: {
    buscarPedido() {
      if (!this.puedeBuscar) return
      const data = {
        numeroDocumento: this.numeroDocumento,
        tipoDocumento: this.tipoDocumento,
        bodegaId: this.bodega.id
      }
      this.$emit('search', data)
    },
    numeroDocumentoEnterHandle() {
      this.buscarPedido()
    }
  }
}
</script>

<style lang="scss" scoped>
.button-alignment {
  margin-top: 32px;
}
</style>
